import 'core-js/modules/es.array.includes.js';

var ALPHABETIC_CHARACTERS = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
var isAlphabeticCharacter = function isAlphabeticCharacter(s) {
  return ALPHABETIC_CHARACTERS.includes(s);
};
var SPECIAL_CHARACTERS = ['Escape', '/'];
var isSpecialCharacter = function isSpecialCharacter(s) {
  return SPECIAL_CHARACTERS.includes(s);
};
var isControlKey = function isControlKey(s) {
  return s === 'Ctrl';
};
var isMetaKey = function isMetaKey(s) {
  return s === 'Meta';
};
var isKeyPressed = function isKeyPressed(event, key) {
  if (isAlphabeticCharacter(key) || isSpecialCharacter(key)) {
    return event.key === key;
  }
  if (isMetaKey(key)) {
    return event.metaKey;
  }
  if (isControlKey(key)) {
    return event.ctrlKey;
  }
  return false;
};
var getKeyLabel = function getKeyLabel(key) {
  if (isAlphabeticCharacter(key)) {
    return key.toUpperCase();
  }
  if (isSpecialCharacter(key)) {
    switch (key) {
      case '/':
        return '/';
      case 'Escape':
        return 'Esc';
    }
  }
  if (isMetaKey(key)) {
    return '⌘';
  }
  if (isControlKey(key)) {
    return 'Ctrl';
  }
  return '';
};

export { getKeyLabel, isKeyPressed };
